import { GRID_W, GRID_H, RENDER_SCALE, SURVEY_YEARS, getLake, renderLayer } from "./sampleLake";

const layerCache = {};
export const getLayerCanvas = (layer) => {
  if (!layerCache[layer]) {
    const c = document.createElement("canvas");
    c.width = GRID_W * RENDER_SCALE;
    c.height = GRID_H * RENDER_SCALE;
    c.getContext("2d").putImageData(renderLayer(layer), 0, 0);
    layerCache[layer] = c;
  }
  return layerCache[layer];
};

const pill = (ctx, text, x, y, k, align = "left", accent = "#67E8F9") => {
  ctx.font = `bold ${11 * k}px JetBrains Mono, monospace`;
  const padX = 10 * k, h = 26 * k, w = ctx.measureText(text).width + padX * 2;
  const bx = align === "right" ? x - w : x;
  ctx.fillStyle = "rgba(11,19,43,0.82)";
  ctx.beginPath(); ctx.roundRect(bx, y, w, h, 7 * k); ctx.fill();
  ctx.strokeStyle = "rgba(148,163,184,0.35)"; ctx.lineWidth = 1; ctx.stroke();
  ctx.fillStyle = accent; ctx.textAlign = "left"; ctx.textBaseline = "middle";
  ctx.fillText(text, bx + padX, y + h / 2 + 0.5);
};

const drawBase = (ctx, w, h, k, { layer, compare, split }) => {
  if (!compare) {
    ctx.drawImage(getLayerCanvas(layer), 0, 0, w, h);
    return;
  }
  const a = getLayerCanvas("vegetation"), b = getLayerCanvas("vegetation2025");
  const cut = Math.max(1, Math.min(w - 1, Math.round(split * w)));
  const sCut = (cut / w) * a.width;
  ctx.drawImage(a, 0, 0, sCut, a.height, 0, 0, cut, h);
  ctx.drawImage(b, sCut, 0, b.width - sCut, b.height, cut, 0, w - cut, h);
  ctx.fillStyle = "#FFFFFF";
  ctx.fillRect(cut - 1.5 * k, 0, 3 * k, h);
  pill(ctx, `${SURVEY_YEARS.before} · BASELINE`, 12 * k, h - 40 * k, k, "left", "#FCA5A5");
  pill(ctx, `${SURVEY_YEARS.after} · POST-TREATMENT`, w - 12 * k, h - 40 * k, k, "right", "#86EFAC");
};

const drawTransects = (ctx, sx, sy, k) => {
  const { depth } = getLake();
  ctx.strokeStyle = "rgba(255,255,255,0.28)";
  ctx.lineWidth = 1 * k;
  ctx.setLineDash([3 * k, 4 * k]);
  for (let x = 4; x < GRID_W; x += 6) {
    let start = null;
    for (let y = 0; y <= GRID_H; y++) {
      const wet = y < GRID_H && depth[y * GRID_W + x] > 0;
      if (wet && start === null) start = y;
      if (!wet && start !== null) {
        ctx.beginPath(); ctx.moveTo((x + 0.5) * sx, start * sy); ctx.lineTo((x + 0.5) * sx, y * sy); ctx.stroke();
        start = null;
      }
    }
  }
  ctx.setLineDash([]);
};

const drawMeasurement = (ctx, sx, sy, k, points) => {
  const [a, b] = points;
  if (b) {
    ctx.strokeStyle = "#FDE68A"; ctx.lineWidth = 2 * k; ctx.setLineDash([6 * k, 4 * k]);
    ctx.beginPath(); ctx.moveTo(a.gx * sx, a.gy * sy); ctx.lineTo(b.gx * sx, b.gy * sy); ctx.stroke();
    ctx.setLineDash([]);
  }
  points.forEach((p, i) => {
    ctx.fillStyle = "#FDE68A"; ctx.strokeStyle = "#0A0F1D"; ctx.lineWidth = 2 * k;
    ctx.beginPath(); ctx.arc(p.gx * sx, p.gy * sy, 6 * k, 0, Math.PI * 2); ctx.fill(); ctx.stroke();
    ctx.fillStyle = "#0A0F1D"; ctx.font = `bold ${9 * k}px JetBrains Mono, monospace`; ctx.textAlign = "center"; ctx.textBaseline = "middle";
    ctx.fillText(i === 0 ? "A" : "B", p.gx * sx, p.gy * sy + 0.5 * k);
  });
};

const drawHover = (ctx, w, h, sx, sy, hover) => {
  ctx.strokeStyle = "rgba(255,255,255,0.7)"; ctx.lineWidth = 1; ctx.setLineDash([2, 3]);
  ctx.beginPath(); ctx.moveTo(hover.gx * sx, 0); ctx.lineTo(hover.gx * sx, h); ctx.stroke();
  ctx.beginPath(); ctx.moveTo(0, hover.gy * sy); ctx.lineTo(w, hover.gy * sy); ctx.stroke();
  ctx.setLineDash([]);
  ctx.strokeStyle = "#67E8F9"; ctx.lineWidth = 2;
  ctx.beginPath(); ctx.arc(hover.gx * sx, hover.gy * sy, 7, 0, Math.PI * 2); ctx.stroke();
};

// Draws the full map view (layer / compare split, transects, measurement, hover) into ctx at w x h.
export function drawMap(ctx, w, h, { layer, showTransects, points = [], hover = null, compare = false, split = 0.5 }) {
  const k = w / 760;
  const sx = w / GRID_W, sy = h / GRID_H;
  ctx.imageSmoothingEnabled = true;
  drawBase(ctx, w, h, k, { layer, compare, split });
  if (showTransects) drawTransects(ctx, sx, sy, k);
  if (points.length) drawMeasurement(ctx, sx, sy, k, points);
  if (hover) drawHover(ctx, w, h, sx, sy, hover);
}
